export var MORE_RESULTS_TYPE = 'more-results';
export var GlobalSearchUtils = {
    createMoreResultListItem: function (count) { return ({
        objectType: MORE_RESULTS_TYPE,
        id: 0,
        name: "Show all results (" + count + ")"
    }); },
    looseFocus: function () {
        var inputs = document.querySelectorAll('.globalSearch input');
        inputs.forEach(function (input) { return input.blur(); });
    },
    /**
     * this method was taken from:
     * https://www.npmjs.com/package/react-highlight-words
     * https://codesandbox.io/s/k20x3ox31o?file=/src/index.js:982-2631
     */
    findChunksAtBeginningOfWords: function (_a) {
        var autoEscape = _a.autoEscape, caseSensitive = _a.caseSensitive, sanitize = _a.sanitize, searchWords = _a.searchWords, textToHighlight = _a.textToHighlight;
        var chunks = [];
        var textLow = textToHighlight.toLowerCase();
        // Match at the beginning of each new word
        // New word start after whitespace, '_', '-', '.' or '('
        //    - left bracket is here to highlight word which is synonym to BT. It is wrapper in brackets
        var sep = /[\s_\-.(]+/;
        // Match at the beginning of each new word
        // New word start after whitespace or - (hyphen)
        var singleTextWords = textLow.split(sep);
        // It could be possible that there are multiple spaces between words
        // Hence we store the index (position) of each single word with textToHighlight
        var fromIndex = 0;
        var singleTextWordsWithPos = singleTextWords.map(function (s) {
            var indexInWord = textLow.indexOf(s, fromIndex);
            fromIndex = indexInWord;
            return {
                word: s,
                index: indexInWord
            };
        });
        // Add chunks for every searchWord
        searchWords.forEach(function (sw) {
            var swLow = sw.toLowerCase();
            // Do it for every single text word
            singleTextWordsWithPos.forEach(function (s) {
                if (s.word.startsWith(swLow)) {
                    var start = s.index;
                    var end = s.index + swLow.length;
                    chunks.push({
                        start: start,
                        end: end
                    });
                }
            });
            // The complete word including whitespace should also be handled, e.g.
            // searchWord='Angela Mer' should be highlighted in 'Angela Merkel'
            if (textLow.startsWith(swLow)) {
                var start = 0;
                var end = swLow.length;
                chunks.push({
                    start: start,
                    end: end
                });
            }
        });
        return chunks;
    }
};
export default GlobalSearchUtils;
//# sourceMappingURL=globalSearchUtils.js.map